if (!customElements.get("comparitor-section")) {
  class ComparitorSection extends HTMLElement {
    constructor() {
      super();
      this.contexts = ["first", "second"];
      this.elements = {};

      // pull in all per-context elements
      this.contexts.forEach((ctx) => {
        const wrapper = this.querySelector(`.product-selectors .selector[data-option="${ctx}"]`);
        this.elements[ctx] = {
          wrapper,
          selector: wrapper.querySelector('.modal-opener'),
          spinner: wrapper.querySelector('.loading-overlay__spinner'),
          info: wrapper.querySelector('.product-info'),
          image: wrapper.querySelector('.product-image'),
          removeBtn: wrapper.querySelector('.remove-selection-button'),
        };
      });

      // modal & misc
      this.modal = this.querySelector('.comparitor-selection-modal');
      this.modalProducts = this.modal.querySelectorAll('.product-thumbnail');
      this.modalClose = this.modal.querySelector('.comparitor-modal-close');
      this.modalBg = this.modal.querySelector('.modal-bg');
      this.header = document.querySelector('.section-header');
      this.body = document.body;

      this.currentContext = null;
      this.selectedUrls = { first: "", second: "" };
    }

    connectedCallback() {
      // open modal & clear buttons
      this.contexts.forEach((ctx) => {
        this.elements[ctx].selector.addEventListener('click', () => this.openModal(ctx));
        this.elements[ctx].removeBtn.addEventListener('click', () => this.clearSelection(ctx));
        this.elements[ctx].info.addEventListener('click', () => this.bringToFront(ctx));
      });

      // modal events
      this.modalClose.addEventListener('click', () => this.hideModal());
      this.modalBg  .addEventListener('click', () => this.hideModal());

      // choose product
      this.modalProducts.forEach((thumb) =>
        thumb.addEventListener('click', () =>
          this.selectProduct(thumb.dataset.productUrl)
        )
      );

      this.loadFromUrl();
    }

    openModal(ctx) {
      this.currentContext = ctx;
      this.modal.classList.remove('hidden');
      this.header.classList.add('hidden');
      this.body.style.overflow = 'hidden';
    }

    hideModal() {
      this.modal.classList.add('hidden');
      this.header.classList.remove('hidden');
      this.body.style.overflow = '';
    }

    clearSelection(ctx) {
      const el = this.elements[ctx];
      el.selector.classList.remove('hidden');
      el.info.innerHTML = '';
      el.image.innerHTML = '';
      el.removeBtn.classList.add('hidden');
      this.modalProducts.forEach(p =>
        p.dataset.productUrl === this.selectedUrls[ctx] && p.classList.remove('selected')
      );
      this.selectedUrls[ctx] = '';
      this.updateHistory();
    }

    bringToFront(activeCtx) {
      this.contexts.forEach((ctx) => {
        const z = ctx === activeCtx ? 2 : 1;
        this.elements[ctx].info .style.zIndex = z;
        this.elements[ctx].wrapper.style.zIndex = z;
      });
    }

    selectProduct(url) {
      this.hideModal();
      this.loadProduct(url, this.currentContext);
    }

    loadFromUrl() {
      const params = new URLSearchParams(window.location.search);
      this.contexts.forEach((ctx, i) => {
        const handle = params.get(`compare-product-${i+1}`);
        if (handle) this.loadProduct(`/products/${handle}`, ctx);
      });
    }

    loadProduct(url, ctx) {
      const el = this.elements[ctx];
      this.classList.add('loading');
      this.selectedUrls[ctx] = url;
      el.selector.classList.add('hidden');
      el.spinner .classList.remove('hidden');
      this.updateHistory();

      return fetch(url)
        .then(r => { if (!r.ok) throw new Error(r.statusText); return r.text(); })
        .then(html => {
          this.classList.remove('loading');
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const info  = doc.querySelector('product-info');
          const image = doc.querySelector('media-gallery ul li:first-child img');

          el.info .innerHTML = '';
          el.info .append(info);
          el.image.innerHTML = '';
          el.image.append(image);

          el.spinner .classList.add('hidden');
          el.removeBtn.classList.remove('hidden');

          // re-inject any inline scripts
          ['readMoreScript','specifications-script','upsells-specification-script'].forEach(id => {
            const old = el.info.querySelector(`#${id}`);
            if (!old) return;
            const nw = document.createElement('script');
            old.src ? (nw.src = old.src) : (nw.innerHTML = old.innerHTML);
            old.replaceWith(nw);
          });
        })
        .catch(console.error);
    }

    updateHistory() {
      let url = window.location.pathname;
      const parts = [];

      this.contexts.forEach((ctx, i) => {
        if (this.selectedUrls[ctx]) {
          const handle = this.selectedUrls[ctx].split('/').pop();
          parts.push(`compare-product-${i+1}=${handle}`);
          // highlight in modal
          this.modalProducts.forEach(p => {
            p.classList.toggle(
              'selected',
              p.dataset.productUrl === this.selectedUrls[ctx]
            );
          });
        }
      });

      if (parts.length) url += `?${parts.join('&')}`;
      window.history.pushState({}, '', url);
    }
  }

  customElements.define('comparitor-section', ComparitorSection);
}
